/** Defensive array helpers for roster / attendance async data. */

export function asArray(value) {
  if (Array.isArray(value)) return value;
  if (value == null) return [];
  if (Array.isArray(value.items)) return value.items;
  if (Array.isArray(value.data)) return value.data;
  if (Array.isArray(value.results)) return value.results;
  if (Array.isArray(value.records)) return value.records;
  return [];
}

export function normalizeEmployeeListResponse(data) {
  const items = asArray(data?.items ?? data);
  return { items, total: data?.total ?? items.length };
}

export function normalizeRosterValidation(data) {
  if (!data || typeof data !== "object") return null;
  return {
    ...data,
    errors: asArray(data.errors),
    warnings: asArray(data.warnings),
    error_count: Number(data.error_count ?? asArray(data.errors).length),
    warning_count: Number(data.warning_count ?? asArray(data.warnings).length),
  };
}
